
import { useState } from 'react';

export default function Products() {
  const [activeCategory, setActiveCategory] = useState('all');

  const products = [
    {
      category: 'alarm',
      name: 'Smart Alarm Panel',
      description: 'Touchscreen control panel with voice control and mobile app integration',
      image: 'https://public.readdy.ai/ai/img_res/85521419e5f097a17df979bc3aa5eef7.jpg',
      features: ['7" HD touchscreen', 'Voice assistant ready', 'Wireless connectivity']
    },
    {
      category: 'camera',
      name: 'Outdoor IP Camera',
      description: '4K resolution with night vision and weatherproof design for outdoor monitoring',
      image: 'https://readdy.ai/api/search-image?query=Professional%20white%20outdoor%20security%20IP%20camera%20with%20sleek%20modern%20cylindrical%20design%20mounted%20on%20clean%20surface%20showing%20lens%20and%20infrared%20sensors%20weatherproof%20housing%20with%20premium%20finish%20simple%20neutral%20background%20highlighting%20advanced%20surveillance%20technology%20and%20build%20quality&width=600&height=600&seq=prod002&orientation=squarish',
      features: ['4K Ultra HD', 'Night vision 100ft', 'Weather resistant']
    },
    {
      category: 'camera',
      name: 'Indoor IP Camera',
      description: 'Compact indoor camera with pan-tilt-zoom and two-way audio communication',
      image: 'https://readdy.ai/api/search-image?query=Compact%20white%20indoor%20security%20camera%20with%20modern%20spherical%20design%20on%20adjustable%20base%20showing%20camera%20lens%20and%20motion%20sensor%20sleek%20minimalist%20aesthetic%20placed%20on%20clean%20surface%20with%20simple%20background%20emphasizing%20smart%20home%20integration%20and%20contemporary%20style&width=600&height=600&seq=prod003&orientation=squarish',
      features: ['1080p HD video', 'Pan-tilt-zoom', 'Two-way audio']
    },
    {
      category: 'sensor',
      name: 'Door/Window Sensors',
      description: 'Wireless sensors that detect when doors or windows are opened',
      image: 'https://readdy.ai/api/search-image?query=White%20wireless%20door%20and%20window%20security%20sensors%20with%20compact%20rectangular%20design%20showing%20magnetic%20contact%20points%20modern%20minimalist%20style%20displayed%20on%20clean%20surface%20with%20simple%20background%20highlighting%20smart%20home%20security%20technology%20and%20easy%20installation&width=600&height=600&seq=prod004&orientation=squarish',
      features: ['Wireless design', 'Long battery life', 'Instant alerts']
    },
    {
      category: 'sensor',
      name: 'Motion Detectors',
      description: 'Advanced PIR sensors with pet immunity up to 40 lbs',
      image: 'https://readdy.ai/api/search-image?query=White%20wall-mounted%20motion%20detector%20sensor%20with%20modern%20curved%20design%20showing%20infrared%20detection%20lens%20sleek%20contemporary%20appearance%20on%20clean%20background%20emphasizing%20advanced%20PIR%20technology%20and%20smart%20home%20security%20integration&width=600&height=600&seq=prod005&orientation=squarish',
      features: ['Pet-friendly', 'Wide coverage', 'False alarm prevention']
    },
    {
      category: 'alarm',
      name: 'Smart Doorbell',
      description: 'Video doorbell with HD camera, motion detection, and two-way talk',
      image: 'https://readdy.ai/api/search-image?query=Modern%20smart%20video%20doorbell%20with%20sleek%20black%20rectangular%20design%20showing%20camera%20lens%20and%20doorbell%20button%20contemporary%20minimalist%20style%20displayed%20on%20clean%20surface%20with%20simple%20background%20highlighting%20premium%20build%20quality%20and%20smart%20home%20technology&width=600&height=600&seq=prod006&orientation=squarish',
      features: ['1080p camera', 'Motion alerts', 'Cloud recording']
    }
  ];

  const filteredProducts = activeCategory === 'all' 
    ? products 
    : products.filter(p => p.category === activeCategory);

  return (
    <section id="products" className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-16 gap-6">
          <div>
            <div className="inline-block px-4 py-1.5 border border-white/30 text-white rounded-full text-sm font-semibold mb-4">
              OUR SYSTEMS
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              SECURITY SOLUTIONS<br />FOR EVERY HOME
            </h2>
          </div>
          <div className="flex gap-3">
            <button 
              onClick={() => setActiveCategory('all')}
              className={`whitespace-nowrap px-5 py-2 rounded-full text-sm font-semibold transition-all cursor-pointer ${activeCategory === 'all' ? 'bg-teal-600 text-white' : 'bg-white/10 text-white hover:bg-white/20'}`}
            >
              All Products
            </button>
            <button 
              onClick={() => setActiveCategory('alarm')}
              className={`whitespace-nowrap px-5 py-2 rounded-full text-sm font-semibold transition-all cursor-pointer ${activeCategory === 'alarm' ? 'bg-teal-600 text-white' : 'bg-white/10 text-white hover:bg-white/20'}`}
            >
              Alarms
            </button>
            <button 
              onClick={() => setActiveCategory('camera')}
              className={`whitespace-nowrap px-5 py-2 rounded-full text-sm font-semibold transition-all cursor-pointer ${activeCategory === 'camera' ? 'bg-teal-600 text-white' : 'bg-white/10 text-white hover:bg-white/20'}`}
            >
              Cameras
            </button>
            <button 
              onClick={() => setActiveCategory('sensor')}
              className={`whitespace-nowrap px-5 py-2 rounded-full text-sm font-semibold transition-all cursor-pointer ${activeCategory === 'sensor' ? 'bg-teal-600 text-white' : 'bg-white/10 text-white hover:bg-white/20'}`}
            >
              Sensors
            </button>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProducts.map((product, index) => (
            <div key={index} className="bg-gray-50 rounded-3xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300">
              <div className="w-full h-80 bg-white">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6 bg-gray-900">
                <h3 className="text-xl font-bold text-white mb-2">{product.name}</h3>
                <p className="text-gray-400 text-sm mb-4">{product.description}</p>
                <ul className="space-y-2 mb-4">
                  {product.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-sm text-gray-300">
                      <i className="ri-check-line text-teal-500"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
